<template>
  <el-dialog
    :class="['my-common-modal', className]"
    :modal="true"
    :visible.sync="myVisible"
    :append-to-body="true"
    :title="title"
    :before-close="handleClose"
    :close-on-click-modal="false"
    top="0vh"
    :width="width"
  >
    <slot></slot>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    title: String,
    width: {
      type: String,
      default: '300px'
    },
    className: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      myVisible: false
    };
  },
  methods: {
    handleClose() {
      this.myVisible = false;
      this.$emit('close');
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.myVisible = val;
      },
      immediate: true
    },
    myVisible: {
      handler(val) {
        this.$emit('update:visible', val);
      }
    }
  }
};
</script>

<style lang="less">
.my-common-modal {
  position: static;
  user-select: none;
  .el-dialog {
    transform: translateX(-50%) translateY(-50%);
    position: absolute;
    top: 30%;
    left: 50%;

    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background: linear-gradient(
        to bottom,
        #76b4de 0%,
        #9fcaea 20%,
        #c8e0f5 50%,
        #c8e0f5 100%
      );
    }

    .el-dialog__body {
      background-color: #c8e0f5;
      border-radius: 0 0 10px 10px;
      padding: 0px;
      overflow: hidden;
    }
  }
  z-index: 0;
}
</style>
